import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import PageTitle from 'components/PageTitle';
import Button from 'components/Button';
import { setStorage } from 'utilz';

import { URLS } from 'config';

import './styles.scss';
import containerActions from './actions';
// import { API } from '../../config';

class WorkingPage extends React.Component {
  state = {}

  selectWorkingHandl = working => () => {
    setStorage({
      working: {
        working
      }
    });
    this.disagreeHandl();
    this.props.workingChangeHandl(working);

    this.props.workingSend(() => {
      if (working) {
        this.props.history.push(URLS.EXPERIENCE);
      }
    });
  };
  disagreeHandl = () => {
    this.props.confirmationChangeHandl(false);

    this.props.confirmationSend(() => {
      setStorage({
        confirmation: {
          confirmation: false
        }
      });
    });
  }
  downPaymentHandl = downPayment => () => {
    this.disagreeHandl();
    this.props.workingChangeHandl(false);
    setStorage({
      working: {
        working: false
      }
    });
    this.props.workingSend();
    this.props.downPaymentChangeHandl(downPayment);
    setStorage({
      working: {
        working: this.props.working,
        downPayment
      }
    });
    this.props.downPaymentSend(() => {
      this.props.history.push(downPayment ? URLS.DOWNPAYMENTS : URLS.BUDGET);
    });
  }

  render() {
    return (
      <div className="page-working">
        { <PageTitle>Are you working?</PageTitle> }
        <div className="working-types">
          <Button
            disabled={false}
            onClick={this.selectWorkingHandl(true)}
          >
            Yes
          </Button>
          <Button
            disabled={false}
            onClick={this.downPaymentHandl(true)}
          >
            No
          </Button>
        </div>
      </div>
    );
  }
}

WorkingPage.propTypes = {
  // eslint-disable-next-line
  history: PropTypes.object.isRequired,
  workingChangeHandl: PropTypes.func.isRequired,
  confirmationChangeHandl: PropTypes.func.isRequired,
  confirmationSend: PropTypes.func.isRequired,
  workingSend: PropTypes.func.isRequired,
  downPaymentSend: PropTypes.func.isRequired,
  downPaymentChangeHandl: PropTypes.func.isRequired,
  working: PropTypes.bool.isRequired
};

const mapStateToProps = state => ({
  working: state.working.working
});

export default connect(mapStateToProps, containerActions)(WorkingPage);



// WEBPACK FOOTER //
// ./src/pages/Working/index.js